<div data-layout-container="true" class="layout-container">
  <div class="header-div">
    <header>
      <app-topnav></app-topnav>
    </header>
  </div>
  <div data-testid="Navigation" class="css-vwrpzw" [ngStyle]="{'display': isMobileDevice ? 'none' : 'block'}">
    <div class="css-xbia9">
      <div data-testid="ContextualNavigation" class="css-1o3fej">
        <div class="css-xdwmn0">
          <div class="css-1hpn4bw">
            <div class="css-1tw9lwf">
              <app-leftnav></app-leftnav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div data-testid="Content" class="layout-data-container" [ngStyle]="{'padding-left.px': isMobileDevice ? 0 : 240}">
    <div>
      <div class="content-container">
        <div class="css-8ypwyz efo6slf1">
          <div class="css-i3pbo e1jzw51l0">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
